import {Highlight, TextImage} from '@sdox/ui'
import {BlockHighlightVisualizationEnum} from '@sdox/api'

import {GenericButton} from '../Buttons/GenericButton'
import {useBlockSiblings} from '../../hooks/useBlockSiblings'
import {xcMediaRefToMediaItem} from '../../utils'

import type {ResponsiveMediaType} from '@sdox/ui'
import type {XcNwBlock_BlockHighlightType_Fragment} from '@sdox/api'

export type BlockHighlightProps = XcNwBlock_BlockHighlightType_Fragment

export const BlockHighlight = (props: BlockHighlightProps) => {
  const {
    cta,
    highlightDescription,
    highlightTitle,
    media,
    mediaMobile,
    visualization,
  } = props

  const responsiveMedia: ResponsiveMediaType = {
    desktop: xcMediaRefToMediaItem(media),
    mobile: mediaMobile ? xcMediaRefToMediaItem(mediaMobile) : undefined,
  }

  const {next} = useBlockSiblings(props)

  const isHighlightVisualization = (
    visualization === BlockHighlightVisualizationEnum.Default ||
    visualization === BlockHighlightVisualizationEnum.ViceVersa
  )

  const isTextImageVisualization = (
    visualization === BlockHighlightVisualizationEnum.TextImage ||
    visualization === BlockHighlightVisualizationEnum.TextImageViceVersa
  )

  const isViceVersa = (
    visualization === BlockHighlightVisualizationEnum.ViceVersa ||
    visualization === BlockHighlightVisualizationEnum.TextImageViceVersa
  )

  const mediaPosition = isViceVersa ? 'trailing' : 'leading'

  // pullout is handled in SectionBlocksTemplate.
  if (isHighlightVisualization) {

    return (
      <Highlight
        media={responsiveMedia}
        headline={highlightTitle}
        callout={highlightDescription}
        mediaPosition={mediaPosition}
        cta={(
          cta ? <GenericButton {...cta}/> : undefined
        )}
      />
    )
  }
  if (isTextImageVisualization) {
    const showBottomBorder = (
      next?.__typename === 'BlockHighlightType' && (
        next.visualization === BlockHighlightVisualizationEnum.TextImage ||
        next.visualization === BlockHighlightVisualizationEnum.TextImageViceVersa
      )
    )
    return (
      <TextImage
        media={responsiveMedia}
        headline={highlightTitle}
        callout={highlightDescription}
        mediaPosition={mediaPosition}
        showBottomBorder={showBottomBorder}
        cta={(
          cta ? <GenericButton {...cta}/> : undefined
        )}
      />
    )
  }

  // Check that all visualizations have been handled
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const exhaustiveCheck: never = visualization
}
